import { useRef } from "react";
import { Animated } from "react-native";
import useTheme from "src/customizations/themes/hooks/useTheme";
import useIsOnline from "../hooks/useIsOnline";
export default function useAnimations() {
    const heightAnim = useRef(new Animated.Value(0)).current;
    const opacityAnim = useRef(new Animated.Value(0)).current;
    const textOpacityAnim = useRef(new Animated.Value(0)).current;
    const getAnimateIn = () => {
        // Animate height and opacity in
        return Animated.parallel([
            Animated.timing(heightAnim, {
                toValue: 1,
                duration: 300,
                useNativeDriver: false,
            }),
            Animated.timing(opacityAnim, {
                toValue: 1,
                duration: 300,
                useNativeDriver: false,
            }),
            Animated.timing(textOpacityAnim, {
                toValue: 1,
                duration: 300,
                useNativeDriver: false,
            }),
        ]);
    };
    const getAnimateOut = (isOnlineState) => {
        return Animated.parallel([
            Animated.timing(heightAnim, {
                toValue: isOnlineState ? 0 : 0.2,
                duration: 300,
                useNativeDriver: false,
            }),
            isOnlineState ? Animated.timing(opacityAnim, {
                toValue: 0,
                duration: 300,
                useNativeDriver: false,
            }) : null,
            Animated.timing(textOpacityAnim, {
                toValue: 0,
                duration: 200,
                useNativeDriver: false,
            }),
        ].filter(Boolean));
    };
    const isOnline = useIsOnline();
    const [{ theme }] = useTheme();
    const containerHeight = heightAnim.interpolate({
        inputRange: [0, 0.2, 1],
        outputRange: [0, 12, 50], // 0px, 15px (reduced), 50px (full)
    });
    const backgroundColor = isOnline
        ? theme.palette.positive.main
        : theme.palette.negative.main;
    const containerAnimatedStyle = {
        height: containerHeight,
        opacity: opacityAnim,
        backgroundColor,
    };
    const textAnimatedStyle = {
        opacity: textOpacityAnim,
    };
    return {
        containerAnimatedStyle,
        textAnimatedStyle,
        getAnimateIn,
        getAnimateOut
    };
}
